<ng-container *ngIf="(payments$ | async) as payments">
  <table class="table" *ngIf="payments.length > 0">
    <thead>
      <tr>
        <th>{{ 'table.date' | translate }}</th>
        <th>{{ 'table.paid' | translate }}</th>
        <th class="center">{{ 'table.status' | translate }}</th>
        <th class="action-column center">{{ 'table.receipt' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let payment of payments">
        <td>{{ payment.createdOn | date: 'dd.MM.yyyy' }}</td>
        <td>{{ payment.amount }} {{ 'subscription.plan.currency.' + payment.currency | translate | uppercase }}</td>
        <td class="center">
          <app-status-label
            [label]="{
              name: 'subscription.payment_status.' + payment.status | translate | lowercase,
              color: getLabel(payment)!
            }"></app-status-label>
        </td>
        <td class="center">
          <a (click)="sendReceiptEmail(payment)" *ngIf="isReceiptAvailable(payment)"><span class="icon-hover icon-Save" [matTooltip]="'actions.send' | translate"></span></a>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>
